import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
    name: "resultStatus",
    standalone: false
})
export class ResultStatusPipe implements PipeTransform {
    public transform(value: number | undefined, dangerLimit: number = 0): string {
        if (!value) return "danger";
        const count: string = value < dangerLimit ? "success" : "danger";
        return count;
    }
}
